import { HiX } from 'react-icons/hi';
import Links from './components/Links';
import routes from 'routes';
import { useAdminsStore } from 'views/store/useAdminsStore';

const Sidebar = (props: {
  open: boolean;
  onClose: () => void;
}) => {
  const { open, onClose } = props;
  const { currentRole } = useAdminsStore();
  const handleCloseOnLinkClick = () => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    if (mediaQuery.matches) {
      return;
    }

    onClose()
  }
  const filteredRoutes = routes.filter(route => !(route.path === "manageAdmin" && currentRole !== "SUPER_ADMIN"));
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full w-full sm:max-w-[270px] flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? 'translate-x-0' : '-translate-x-[650px]'
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="ml-1 mt-1 font-poppins text-[26px] font-bold uppercase text-navy-700">
          Memelut <br />
          <span className="font-medium">Dashboard</span>
        </div>
      </div>
      <div className="mb-7 mt-[58px] h-px bg-gray-300" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={filteredRoutes} onClose={handleCloseOnLinkClick}/>
      </ul>
      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
